import { render, staticRenderFns } from "./CopyJobBtn.vue?vue&type=template&id=563be1ec&scoped=true&"
import script from "./CopyJobBtn.vue?vue&type=script&lang=js&"
export * from "./CopyJobBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563be1ec",
  null
  
)

export default component.exports